// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"1e3f336d","334":"db0d88c4","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};